export default function BakerResourcePage() {
    return (
      <div className="min-h-screen bg-pink-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-pink-700 mb-4">🎂 Baker Resources</h1>
          <p className="text-lg text-pink-800 mb-12">
            Curated tools and partners to help your bakery flourish — from cake transport to party décor.
          </p>
        </div>
  
        <div className="grid grid-cols-1 gap-10 max-w-4xl mx-auto">
          {/* CakeSafe */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden transition transform hover:scale-[1.01]">
            <div className="flex flex-col items-center text-center px-6 py-8">
              <img
                src="/baker-resources/cakesafe-thumbnail.png"
                alt="CakeSafe"
                className="w-72 h-48 object-cover rounded-xl shadow-md mb-6 border-2 border-pink-100"
              />
              <h2 className="text-2xl font-bold text-pink-700 mb-2">CakeSafe</h2>
              <p className="text-gray-700 mb-4">
                CakeSafe is a must-have for transporting tall or delicate cakes with confidence.
                Their secure delivery systems protect your creations during travel, saving you time,
                stress, and cake repairs. A game-changer for bakers on the move.
              </p>
              <a
                href="https://cakesafe.com/?srsltid=AfmBOopwU6AgNwd7nCLWMzg7UGHJDi7M3ELD3JmllWosCkIsoDnDEvAW"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-600 font-semibold hover:underline"
              >
                Visit CakeSafe →
              </a>
            </div>
          </div>
  
          {/* FSFT */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden transition transform hover:scale-[1.01]">
            <div className="flex flex-col items-center text-center px-6 py-8">
              <img
                src="/baker-resources/fsft-thumbnail.png"
                alt="Frogs Snails and Fairy Tales"
                className="w-72 h-48 object-cover rounded-xl shadow-md mb-6 border-2 border-pink-100"
              />
              <h2 className="text-2xl font-bold text-pink-700 mb-2">
                Frogs Snails and Fairy Tales (Houston)
              </h2>
              <p className="text-gray-700 mb-4">
                Frogs Snails and Fairy Tales is a magical venue for Children's Birthday parties where special memories begin, and stress-free celebrations are our specialty. 
                Houston bakers love collaborating with them to create
                unforgettable party setups that make their desserts shine in photos and in person.
              </p>
              <a
                href="https://www.fsaft.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-600 font-semibold hover:underline"
              >
                Explore FSFT Rentals →
              </a>
            </div>
            <br></br>
          </div>
        </div>
      </div>
    );
  }
  